import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Concluir", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Unidade")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Quantidade")
  ])
], -1)
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ant-col ant-col-xs-16 ant-col-xl-2" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "ant-col ant-col-xs-5 ant-col-xl-2" }
const _hoisted_19 = { class: "ant-col ant-col-xs-3 ant-col-xl-2 ss-alinhar-centro" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: 'Kit de Produtos',
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "1000px",
    centered: "",
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: "Empresas",
                class: "ss-margin-campos",
                rules: [{ required: true }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_empresa, {
                    varias: true,
                    empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                    codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                    "onUpdate:codigosSelecionados": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                  }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, _ctx.telaBase.apresentarEmpresas]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Código Interno",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.kit.codigoInterno) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.kit.codigoInterno]
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_form_item, {
                label: "Descrição do Kit",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.kit.descricao) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.kit.descricao]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_card, { titulo: "Itens" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_form_item, {
                    label: "Produto",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_produto, {
                        empresas: [_ctx.props.empresa],
                        apresentarCodigoInterno: true,
                        codigoSelecionado: _ctx.state.produtoSelecionado,
                        "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.produtoSelecionado) = $event)),
                        descricaoSelecionado: _ctx.state.descricaoProduto,
                        "onUpdate:descricaoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.descricaoProduto) = $event)),
                        modoDefinicaoProduto: true,
                        semKits: true
                      }, null, 8, ["empresas", "codigoSelecionado", "descricaoSelecionado"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_form_item, {
                    label: "Unidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_selecionar_unidade_produto_movimento, {
                        key: _ctx.state.produtoSelecionado,
                        apenasUnidadePrincipal: false,
                        codigoProdutoDefinicao: _ctx.state.produtoSelecionado,
                        "onUpdate:codigoProdutoDefinicao": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.produtoSelecionado) = $event)),
                        codigoUnidadeSelecionada: _ctx.state.unidadeSelecionada,
                        "onUpdate:codigoUnidadeSelecionada": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.unidadeSelecionada) = $event)),
                        apresentarApenasSigla: true,
                        buscarDadosAtualizados: _ctx.state.carregandoUnidade,
                        descricao: _ctx.state.descricaoUnidade,
                        "onUpdate:descricao": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.descricaoUnidade) = $event)),
                        casasDecimais: _ctx.state.casasDecimais,
                        "onUpdate:casasDecimais": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.casasDecimais) = $event))
                      }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "buscarDadosAtualizados", "descricao", "casasDecimais"]))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_form_item, {
                    label: "Quantidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        "quantidade-casas-decimais": _ctx.state.casasDecimais,
                        valor: _ctx.state.quantidade,
                        "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.quantidade) = $event))
                      }, null, 8, ["quantidade-casas-decimais", "valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_form_item, {
                    label: " ",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-secondary ant-btn-block",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.adicionarItem && _ctx.adicionarItem(...args)))
                      }, "Adicionar")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _hoisted_13,
              (!_ctx.UtilitarioGeral.validaLista(_ctx.state.kit.itens))
                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                    key: 0,
                    mensagem: "Nenhuma item informado ainda"
                  }))
                : (_openBlock(), _createBlock(_component_a_form, {
                    key: 1,
                    name: "ss-form-produto-fornecedores",
                    class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.kit.itens, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "ant-row ss-grade-personalizada-linha",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("input", {
                              class: "ant-input",
                              type: "text",
                              value: item.descricaoProduto,
                              disabled: ""
                            }, null, 8, _hoisted_15)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("input", {
                              class: "ant-input",
                              type: "text",
                              value: item.descricaoUnidade,
                              disabled: ""
                            }, null, 8, _hoisted_17)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_campo_numerico, {
                              "quantidade-casas-decimais": item.casasDecimais,
                              valor: item.quantidade,
                              disabled: true
                            }, null, 8, ["quantidade-casas-decimais", "valor"])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-secondary",
                              onClick: ($event: any) => (_ctx.removerItem(index))
                            }, [
                              _createVNode(_component_icone, { nome: "excluir" })
                            ], 8, _hoisted_20)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            retornoRequisicao: _ctx.modalBase.retornoRequisicao,
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
          }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}